import { useTranslation } from 'react-i18next';
import { registerNamespace } from '../i18n';

export const useAutoTranslation = (ns) => {
  registerNamespace(ns);
  return useTranslation(ns);
};
